export default {
  getHead: () => {
    return [{name: '부서명'}, {name: '회의일'}, {name: '노측 위원(명)'}, {name: '사측 위원(명)'}, {name: '소속명'}, {name: '팀명'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 부서명
        case 1: return func.getContent(value).inputA_2 // 회의일
        case 2: return func.getContent(value).inputA_4 // 노측위원(명)
        case 3: return func.getContent(value).inputA_5 // 사측위원(명)
        case 4: return func.getContent(value).stdInfo.department // 소속명
        case 5: return func.getContent(value).stdInfo.section // 팀명
        case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
      case '부서명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '구분': returnData.push('content$body.inputA_1*%[:default_skw]%'); break
      case '회의일': returnData.push('content$body.inputA_2*%[:default_skw]%'); break
      case '노측 위원(명)': returnData.push('content$body.inputA_4*%[:default_skw]%'); break
      case '사측 위원(명)': returnData.push('content$body.inputA_5*%[:default_skw]%'); break
      case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
      case '팀명': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
    }

    return returnData
  },
}
